"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wasScreenRefreshedDuringCall = exports.JOCallScreen = exports.joCallScreenTagName = void 0;
const lit_html_1 = require("lit-html");
const reduxular_1 = require("reduxular");
const split_js_1 = __importDefault(require("split.js"));
const graphql_1 = require("../../../../services/graphql");
const twilio_1 = require("../../../../services/twilio");
const utilities_1 = require("../../../../services/utilities");
const auth_rules_1 = require("../../../../utilities/auth-rules");
const get_twilio_conversation_sid_1 = require("../../../../utilities/chats/get-twilio-conversation-sid");
const define_custom_element_1 = require("../../../../utilities/define-custom-element");
const user_status_event_mutations_1 = require("../../../../utilities/logging-and-monitoring/user-status-event-mutations");
require("../../jo-button.element");
const chat_duration_event_utils_1 = require("../../jo-chat/chat-utils/chat-duration-event-utils");
require("../../jo-fade-in-overlay");
const jo_home_1 = require("../../jo-home/jo-home");
require("../../jo-loading");
const queries_and_mutations_1 = require("../../jo-quick-text/queries-and-mutations");
require("../jo-action-item-flag-card/jo-action-item-flag-card");
require("../jo-call-screen-call-instructions");
require("../jo-call-screen-collection");
require("../jo-call-screen-company-info");
require("../jo-call-screen-contact-search");
require("../jo-call-screen-dialpad");
require("../jo-call-screen-hold");
require("../jo-flag-action-item-form/jo-flag-action-item-form");
const create_answer_call_action_1 = require("../redux/action-creators/answer-call/create-answer-call-action");
const create_end_call_action_1 = require("../redux/action-creators/end-call/create-end-call-action");
const create_hold_clicked_action_1 = require("../redux/action-creators/hold-clicked/create-hold-clicked-action");
const create_save_contact_action_1 = require("../redux/action-creators/save-contact/create-save-contact-action");
const create_send_action_item_action_1 = require("../redux/action-creators/send-action-item/create-send-action-item-action");
const helper_utils_1 = require("../redux/action-creators/send-action-item/get-action-item-note-inputs/helper-utils");
const mutations_1 = require("../redux/action-creators/send-action-item/mutations");
const action_item_id_set_1 = require("../redux/action-creators/set-action-item-id/action-item-id-set");
const create_set_previous_responses_action_1 = require("../redux/action-creators/set-previous-responses/create-set-previous-responses-action");
const create_close_subscriptions_if_necessary_action_1 = require("../redux/action-creators/subscriptions/create-close-subscriptions-if-necessary-action");
const create_jill_and_user_reconnected_after_transfer_decline_action_1 = require("../redux/action-creators/transfers/create-jill-and-user-reconnected-after-transfer-decline-action");
const create_transfer_complete_action_1 = require("../redux/action-creators/transfers/create-transfer-complete-action");
const create_transfer_decline_action_1 = require("../redux/action-creators/transfers/create-transfer-decline-action");
const create_transfer_initiated_action_1 = require("../redux/action-creators/transfers/create-transfer-initiated-action");
const create_update_durations_action_1 = require("../redux/action-creators/update-durations/create-update-durations-action");
const reducer_1 = require("../redux/reducer");
const state_1 = require("../redux/state");
const assign_jill_to_call_1 = require("../utilities/assign-jill-to-call");
const call_info_for_local_storage_1 = require("../utilities/call-info-for-local-storage");
const chat_info_for_session_storage_1 = require("../utilities/chat-info-for-session-storage");
const publish_chat_queue_updated_event_1 = require("../utilities/publish-chat-queue-updated-event");
const set_user_back_available_automatically_1 = require("../utilities/set-user-back-available-automatically");
const update_last_seen_on_call_for_user_1 = require("../utilities/update-last-seen-on-call-for-user");
const jo_call_screen_utils_1 = require("./jo-call-screen-utils");
const overlay_modal_1 = require("./overlay-modal");
const styles_1 = require("./styles");
const create_element_bound_interval_1 = require("../../../../utilities/timeouts/create-element-bound-interval");
const dates_and_times_1 = require("../../../../utilities/dates-and-times/dates-and-times");
const is_defined_1 = require("../../../../utilities/is-defined");
const element_vir_1 = require("element-vir");
const jo_submit_help_ticket_element_1 = require("../../jo-submit-help-ticket/jo-submit-help-ticket.element");
const replace_not_set_with_undefined_1 = require("../../../../utilities/type-helpers/replace-not-set-with-undefined/replace-not-set-with-undefined");
exports.joCallScreenTagName = 'jo-call-screen';
class JOCallScreen extends HTMLElement {
    constructor() {
        super(...arguments);
        this.store = (0, reduxular_1.createObjectStore)(state_1.InitialJOCallScreenState, (state) => (0, lit_html_1.render)(this.render(state), this), this, reducer_1.RootReducer);
    }
    set props(props) {
        if ((0, utilities_1.deepLeftCheck)(props, this.store.getState()) === true) {
            return;
        }
        const previousActionItemId = this.store.actionItemId;
        const previousUserCallSid = this.store.userCallSid;
        const previousCallScreenMode = this.store.callScreenMode;
        const previousChatId = this.store.chatId;
        const previousState = this.store.getState();
        this.resetStateIfNecessary(props, previousActionItemId);
        this.handleSetProps(props, previousChatId, previousState);
        this.store.preserveState = false;
        if (this.store.authenticatedUser === 'NOT_SET') {
            return;
        }
        this.resetSubscriptionsIfNecessary(previousUserCallSid);
        this.setUpInitialCallScreenInfoIfNecessary(previousCallScreenMode, previousActionItemId);
    }
    saveSelectedChatToSessionStorage() {
        (0, utilities_1.assertIsSet)(this.store.chatId, utilities_1.handleError, 'selected chat Id');
        const contactInputValues = this.store.getState().contactInputValues;
        if (contactInputValues !== 'NOT_SET') {
            const currentState = this.updateContactInCallScreenState(this.store.getState(), contactInputValues);
            (0, chat_info_for_session_storage_1.setChatStateInfoSessionStorage)(this.store.chatId, currentState);
        }
    }
    resetSubscriptionsIfNecessary(previousUserCallSid) {
        if (this.store.userCallSid !== previousUserCallSid) {
            (async () => {
                await this.handleResetSubscriptions();
            })();
        }
    }
    setUpInitialCallScreenInfoIfNecessary(previousCallScreenMode, previousActionItemId) {
        if (this.shouldSetUpInitialCallScreenInfo(previousCallScreenMode, previousActionItemId)) {
            this.store.settingUpInitialCallScreenInfoHasInitiated = true;
            this.handleSetUpInitialCallScreenInfo();
        }
    }
    shouldSetUpInitialCallScreenInfo(previousCallScreenMode, previousActionItemId) {
        return (this.store.settingUpInitialCallScreenInfoHasInitiated === false ||
            (this.store.callScreenMode !== 'CHAT' &&
                this.store.callScreenMode !== previousCallScreenMode) ||
            this.store.actionItemId !== previousActionItemId);
    }
    handleSetProps(props, previousChatId, previousState) {
        if (props.callScreenMode === 'CHAT') {
            this.savePreviousChatStateIfItExistsInSession(previousChatId, previousState);
            this.loadCurrentChatState(props);
        }
        else {
            this.store.dispatch({
                type: 'SET_PROPS',
                props,
            });
        }
        if (isInActiveCallMode(this.store.callScreenMode)) {
            this.startLastSeenOnCallHeartbeatInterval();
        }
    }
    resetStateIfNecessary(props, previousActionItemId) {
        if (props.actionItemId !== previousActionItemId && this.store.preserveState === false) {
            this.store.dispatch({
                type: 'RESET_STATE',
            });
        }
    }
    loadCurrentChatState(props) {
        this.store.dispatch({
            type: 'SET_PROPS',
            props,
        });
        this.store.dispatch({
            type: 'LOAD_CURRENT_CHAT',
            props,
        });
        this.store.settingUpInitialCallScreenInfoHasInitiated = true;
        this.handleSetUpInitialCallScreenInfo();
    }
    savePreviousChatStateIfItExistsInSession(previousChatId, previousState) {
        if (previousChatId !== 'NOT_SET') {
            this.updatePreviousChatInSession(previousChatId, previousState);
        }
    }
    updatePreviousChatInSession(previousChatId, previousState) {
        if (this.store.callScreenMode === 'CHAT' && this.store.contactInputValues !== 'NOT_SET') {
            previousState = this.updateContactInCallScreenState(previousState, this.store.contactInputValues);
            this.store.dispatch({
                type: 'UPDATE_PREVIOUS_CHAT',
                chatId: previousChatId,
                prevState: previousState,
            });
            this.store.dispatch({
                type: 'RESET_STATE',
            });
        }
    }
    startLastSeenOnCallHeartbeatInterval() {
        if ((0, is_defined_1.isDefined)(this.clearLastSeenOnCallHeartbeatInterval)) {
            return;
        }
        this.clearLastSeenOnCallHeartbeatInterval = (0, create_element_bound_interval_1.createElementBoundInterval)({
            callback: async () => {
                if (this.store.authenticatedUser === 'NOT_SET' || !(0, utilities_1.isOnCallScreen)()) {
                    this.stopLastSeenOnCallHeartbeatInterval();
                }
                else {
                    await (0, update_last_seen_on_call_for_user_1.updateLastSeenOnCallForUser)(this.store.authenticatedUser.id, new Date());
                }
            },
            element: this,
            intervalMs: 3 * dates_and_times_1.oneSecondInMilliseconds,
            intervalName: 'last seen on call heartbeat',
        }).clearInterval;
    }
    stopLastSeenOnCallHeartbeatInterval() {
        if (this.clearLastSeenOnCallHeartbeatInterval) {
            this.clearLastSeenOnCallHeartbeatInterval();
            this.clearLastSeenOnCallHeartbeatInterval = undefined;
        }
    }
    async handleResetSubscriptions() {
        this.closeSubscriptionsIfNecessary();
        await this.createInitialSubscriptionsIfNecessary();
    }
    async handleSetUpInitialCallScreenInfo() {
        this.store.settingUpInitialCallScreenInfoHasInitiated = true;
        this.store.loading = true;
        await this.fetchAndSetActionItem();
        await this.fetchAndSetQuickTitles();
        await this.fetchAndSetQuickNotes();
        if (wasScreenRefreshedDuringCall(this.store.getState()) === true) {
            await this.handleCallScreenRefreshedDuringCall();
        }
        else {
            this.handleSettingNewLocalStorageInfoAndDurationCollection();
        }
        this.createIncomingCallLoadedOnCallscreenEventIfNecessary();
        this.store.loading = false;
    }
    createIncomingCallLoadedOnCallscreenEventIfNecessary() {
        if (this.store.callScreenMode === 'INCOMING_NEW_ACTION_ITEM') {
            this.createUserStatusEventOnCallScreen('INCOMING_CALL_LOADED_ON_CALL_SCREEN');
        }
    }
    async handleCallScreenRefreshedDuringCall() {
        await this.sendCallScreenRefreshedDuringCallNotification();
        const mostRecentCallInfoFromLocalStorage = (0, call_info_for_local_storage_1.getMostRecentCallInfoFromLocalStorage)();
        if (mostRecentCallInfoFromLocalStorage !== 'NOT_FOUND' &&
            mostRecentCallInfoFromLocalStorage.answerCallClicked === false) {
            (0, utilities_1.navigate)('/');
        }
    }
    async handleAssignJillToCall() {
        (0, utilities_1.assertIsSet)(this.store.authenticatedUser, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.callId, utilities_1.handleError);
        const assignJillToCallResult = await (0, assign_jill_to_call_1.assignJillToCall)(this.store.callId, this.store.authenticatedUser.id);
        (0, utilities_1.assertSucceeded)(assignJillToCallResult, utilities_1.handleError);
    }
    handleSettingNewLocalStorageInfoAndDurationCollection() {
        if (this.store.callScreenMode !== 'ACTION_ITEM' && this.store.callScreenMode !== 'CHAT') {
            (0, utilities_1.assertIsSet)(this.store.callId, utilities_1.handleError);
            (0, call_info_for_local_storage_1.createAndSetNewCallInfoForLocalStorage)(this.store.callId);
        }
        if (this.store.callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM' &&
            this.store.incomingConnection !== 'NOT_SET') {
            this.store.collectingDuration = true;
        }
    }
    connectedCallback() {
        this.setUpSplitBarDividers();
        this.updateTimeDurations();
    }
    setUpSplitBarDividers() {
        const contactSplit = this.querySelector('#contact-split-container');
        const instructionsSplit = this.querySelector('#instructions-split-container');
        const column2 = this.querySelector('#column-2');
        const column3 = this.querySelector('#column-3');
        if (!contactSplit || !instructionsSplit) {
            return;
        }
        this.createDivindingSplits(contactSplit, instructionsSplit, column2, column3);
    }
    createDivindingSplits(contactSplit, instructionsSplit, column2, column3) {
        (0, split_js_1.default)([
            contactSplit,
            instructionsSplit,
        ], {
            gutterSize: 12,
            sizes: [
                50,
                50,
            ],
            direction: 'vertical',
            minSize: 0,
        });
        (0, split_js_1.default)([
            column2,
            column3,
        ], {
            gutterSize: 12,
            sizes: [
                50,
                50,
            ],
            minSize: 500,
        });
    }
    updateTimeDurations() {
        (0, create_element_bound_interval_1.createElementBoundInterval)({
            callback: () => {
                const updateDurations = (0, create_update_durations_action_1.createUpdateDurationsAction)(this.store.getState());
                this.store.dispatch(updateDurations);
            },
            element: this,
            intervalMs: dates_and_times_1.oneSecondInMilliseconds,
            intervalName: 'update durations',
        });
    }
    async fetchAndSetActionItem() {
        (0, utilities_1.assertIsSet)(this.store.authenticatedUser, utilities_1.handleError, 'authenticatedUser');
        const actionItemIdSetResult = await (0, action_item_id_set_1.createActionItemIdSetAction)(this.store.actionItemId, this.store.authenticatedUser, this.store.companyId, this.store.callScreenMode, this.store.callId, this.store.contact);
        (0, utilities_1.assertSucceeded)(actionItemIdSetResult, utilities_1.handleError, this, 'actionItemIdSetResult');
        const actionItemIdSet = actionItemIdSetResult.value;
        this.store.dispatch(actionItemIdSet);
    }
    async fetchAndSetQuickTitles() {
        const quickTitlesForActionItemResult = await (0, queries_and_mutations_1.fetchGlobalTextList)('ai_quick_titles');
        (0, utilities_1.assertSucceeded)(quickTitlesForActionItemResult);
        this.store.quickTitlesForActionItem = quickTitlesForActionItemResult.value;
        const quickTitlesForAccountHelpTicketResult = await (0, queries_and_mutations_1.fetchGlobalTextList)('account_help_ticket_quick_titles');
        (0, utilities_1.assertSucceeded)(quickTitlesForAccountHelpTicketResult);
        this.store.accountHelpTicketState = {
            ...this.store.accountHelpTicketState,
            quickTitlesForAccountHelpTicket: quickTitlesForAccountHelpTicketResult.value,
        };
    }
    async fetchAndSetQuickNotes() {
        await this.fetchAndSetAIQuickNotes();
        await this.fetchAndSetChatQuickNotes();
    }
    async fetchAndSetChatQuickNotes() {
        (0, utilities_1.assertIsSet)(this.store.companyId);
        const globalChatNotesResult = await (0, queries_and_mutations_1.fetchGlobalTextList)('chat_quick_notes');
        const companyChatNotesResult = await (0, queries_and_mutations_1.fetchTextListForCompany)(this.store.companyId, 'chat_quick_notes');
        (0, utilities_1.assertSucceeded)(globalChatNotesResult);
        (0, utilities_1.assertSucceeded)(companyChatNotesResult);
        this.store.chatMessengerQuickNotes = [
            ...globalChatNotesResult.value,
            ...companyChatNotesResult.value,
        ];
    }
    async fetchAndSetAIQuickNotes() {
        const actionItemNotesResult = await (0, queries_and_mutations_1.fetchGlobalTextList)('ai_quick_notes');
        (0, utilities_1.assertSucceeded)(actionItemNotesResult);
        this.store.actionItemQuickNotes = actionItemNotesResult.value;
    }
    async sendCallScreenRefreshedDuringCallNotification() {
        (0, utilities_1.assertIsSet)(this.store.authenticatedUser, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.callId, utilities_1.handleError);
        await (0, utilities_1.sendCallScreenRefreshedDuringCallAlert)(this.store.authenticatedUser.id, this.store.callId);
    }
    closeSubscriptionsIfNecessary() {
        const createCloseSubscriptionsIfNecessaryActionResult = (0, create_close_subscriptions_if_necessary_action_1.createCloseSubscriptionsIfNecessaryAction)(this.store.subscriptions);
        (0, utilities_1.assertSucceeded)(createCloseSubscriptionsIfNecessaryActionResult, utilities_1.handleError);
        const closeSubscriptionsIfNecessaryAction = createCloseSubscriptionsIfNecessaryActionResult.value;
        this.store.dispatch(closeSubscriptionsIfNecessaryAction);
    }
    async closeChatConversation() {
        if (this.store.chatId !== 'NOT_SET') {
            const result = await (0, mutations_1.updateChatStatusToClosed)(this.store.chatId);
            (0, utilities_1.assertSucceeded)(result, utilities_1.handleError, this, 'jo-call-screen > closeChatConversation() > updateChatStatusToClosed()');
            await (0, mutations_1.sendChatClosedByJillEvent)(this.store.chatId);
            await (0, publish_chat_queue_updated_event_1.publishChatQueueUpdatedMessage)();
            (0, chat_info_for_session_storage_1.removeChatStateInfoSessionStorage)(this.store.chatId);
        }
    }
    async createInitialSubscriptionsIfNecessary() {
        if (shouldSubscribeToIncomingTransferResolved(this.store.getState()) === true) {
            this.subscribeToIncomingTransferResolved();
        }
        if (shouldSubscribeToUserCallStatus(this.store.getState()) === true) {
            this.subscribeToUserCallStatus();
        }
    }
    async subscribeToUserCallStatus() {
        const userCallStatusSubscription = await (0, graphql_1.gqlSubscription)((0, graphql_1.gql) `
                subscription ($userCallSid: String!) {
                    userCallStatusCallback(userCallSid: $userCallSid)
                }
            `, this.userCallStatusEventCallback.bind(this), {
            userCallSid: this.store.userCallSid,
        });
        this.store.subscriptions = {
            ...this.store.subscriptions,
            userCallStatusSubscription: userCallStatusSubscription ?? 'NOT_SET',
        };
    }
    async userCallStatusEventCallback(data) {
        const userCallStatus = data.payload.data.userCallStatusCallback;
        this.store.userCallStatus = userCallStatus;
        if (userCallStatus === 'IN_PROGRESS') {
            return;
        }
        if (this.store.callAnswered === true &&
            this.store.callEnded === false &&
            this.store.onHold === true) {
            await this.handleUserCallEndedDuringHold();
            return;
        }
        if (this.store.callAnswered === true &&
            this.store.callEnded === false &&
            this.store.saveActionItemInitiated === false &&
            this.store.incomingCallType !== 'TRANSFER' &&
            this.store.transferState !== 'STARTED') {
            (0, utilities_1.raiseCustomEvent)(this, 'caninitiatenewtransferchanged', false);
            this.endCall();
        }
    }
    async handleUserCallEndedDuringHold() {
        (0, utilities_1.assertIsSet)(this.store.authenticatedUser, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.callId, utilities_1.handleError);
        const holdEndedDurationEventInfo = {
            description: 'UNHOLD',
            type: 'START',
            timestamp: new Date().toISOString(),
            userId: this.store.authenticatedUser.id,
            callId: this.store.callId,
        };
        this.store.holdButtonEnabled = false;
        (0, twilio_1.setDurationEventLocal)(holdEndedDurationEventInfo);
        await (0, twilio_1.setDurationEventRemote)(holdEndedDurationEventInfo);
        this.endCall();
        this.store.collectingDuration = true;
        this.updateTimeDurations();
        (0, utilities_1.joAlert)('User disconneced', 'The user disconnected while on hold');
    }
    async subscribeToIncomingTransferResolved() {
        (0, utilities_1.assertIsSet)(this.store.jillCallSid, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.userCallSid, utilities_1.handleError);
        const incomingTransferResolvedSubscription = await (0, graphql_1.gqlSubscription)((0, graphql_1.gql) `
                subscription ($jillCallSid: String!, $userCallSid: String!) {
                    transferResolved(transferCallSid: $jillCallSid, userCallSid: $userCallSid)
                }
            `, this.incomingTransferResolvedCallback.bind(this), {
            jillCallSid: this.store.jillCallSid,
            userCallSid: this.store.userCallSid,
        });
        this.store.subscriptions = {
            ...this.store.subscriptions,
            incomingTransferResolvedSubscription: incomingTransferResolvedSubscription ?? 'NOT_SET',
        };
    }
    async incomingTransferResolvedCallback(data) {
        (0, utilities_1.assertIsDefined)(data.payload.data.transferResolved, 'transferResolved payload', utilities_1.handleError);
        const transferResolvedStatus = data.payload.data.transferResolved;
        if (this.store.callAnswered === true &&
            transferResolvedStatus === 'DECLINED' &&
            (this.store.callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
                this.store.callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM')) {
            (0, utilities_1.navigate)(this.store.returnPath);
        }
        if (transferResolvedStatus === 'COMPLETED') {
            this.store.incomingTransferCompleted = true;
        }
        (0, utilities_1.assertIsSet)(this.store.subscriptions.incomingTransferResolvedSubscription, utilities_1.handleError);
        this.store.subscriptions.incomingTransferResolvedSubscription.close();
        this.store.subscriptions = {
            ...this.store.subscriptions,
            incomingTransferResolvedSubscription: 'NOT_SET',
        };
    }
    async answerCall() {
        const answerCallResult = await (0, create_answer_call_action_1.createAnswerCallAction)(this.store.getState());
        (0, utilities_1.assertSucceeded)(answerCallResult, utilities_1.handleError);
        const answerCallAction = answerCallResult.value;
        this.store.dispatch(answerCallAction);
        (0, utilities_1.raiseCustomEvent)(this, 'callansweredchanged', this.store.callAnswered);
        (0, utilities_1.raiseCustomEvent)(this, 'caninitiatenewtransferchanged', true);
    }
    async endCall() {
        if (this.store.endCallActionHasBeenInitiated === true ||
            this.store.saveActionItemInitiated === true) {
            return;
        }
        this.store.endCallActionHasBeenInitiated = true;
        const endCallResult = await (0, create_end_call_action_1.createEndCallAction)(this.store.getState());
        (0, utilities_1.assertSucceeded)(endCallResult, utilities_1.handleError);
        const endCall = endCallResult.value;
        this.store.dispatch(endCall);
        this.closeSubscriptionsIfNecessary();
    }
    createUserStatusEventOnCallScreen(event) {
        if (this.store.authenticatedUser !== 'NOT_SET')
            (0, user_status_event_mutations_1.createUserStatusEvent)({
                userId: this.store.authenticatedUser.id,
                eventType: event,
                timestamp: new Date(),
            });
    }
    async contactSelected(e) {
        this.clearContact();
        this.store.contact = e.detail;
        this.store.hideSearchContainer = true;
        this.store.contactInputValuesForSearch = this.store.contactInputValues;
        await this.publishContactConnectedToChatIfInChatMode();
        const setPreviousResponsesResult = await (0, create_set_previous_responses_action_1.createSetPreviousResponsesAction)(this.store.contact.id, this.store.actionItemId, this.store.companyId);
        (0, utilities_1.assertSucceeded)(setPreviousResponsesResult, utilities_1.handleError);
        const setPreviousResponsesAction = setPreviousResponsesResult.value;
        this.store.dispatch(setPreviousResponsesAction);
        if (this.store.callScreenMode === 'CHAT' && this.store.chatId !== 'NOT_SET') {
            (0, chat_info_for_session_storage_1.setChatStateInfoSessionStorage)(this.store.chatId, this.store.getState());
        }
    }
    clearContact() {
        this.store.dispatch({
            type: 'CLEAR_CONTACT',
        });
    }
    handleDigitEvent(e) {
        (0, utilities_1.assertIsSet)(this.store.incomingConnection, utilities_1.handleError);
        this.store.incomingConnection.sendDigits(e.detail);
    }
    onHoldChanged(e) {
        this.store.onHold = e.detail;
    }
    collectingDurationChanged(e) {
        this.store.collectingDuration = e.detail;
    }
    handleServiceSelected(checked, service) {
        this.store.dispatch({
            type: 'SERVICE_SELECTED',
            checked,
            service,
        });
    }
    async saveContact() {
        (0, utilities_1.assertIsSet)(this.store.companyId, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.contactInputValues, utilities_1.handleError);
        const saveContactResult = await (0, create_save_contact_action_1.createSaveContactAction)(this.store.actionItemId, this.store.callId, this.store.companyId, this.store.contactInputValues);
        (0, utilities_1.assertSucceeded)(saveContactResult, utilities_1.handleError);
        const saveContact = saveContactResult.value;
        this.store.dispatch(saveContact);
    }
    async sendActionItem(e) {
        if (this.store.saveActionItemInitiated === true) {
            return;
        }
        this.store.saveActionItemInitiated = true;
        this.store.loading = true;
        await this.saveContact();
        (0, utilities_1.assertIsSet)(this.store.authenticatedUser, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.companyForCollection, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.contact, utilities_1.handleError);
        await this.publishContactConnectedToChatIfInChatMode();
        const sendActionItemResult = await (0, create_send_action_item_action_1.createSendActionItemAction)(this.store.actionItem, this.store.actionItemId, e.detail.actionItemStatusTypeName, this.store.callScreenMode, this.store.authenticatedUser, this.store.callId, this.store.chatId, this.store.companyForCollection, this.store.contact, this.store.customFieldResponsesInputValues, this.store.followupRequestDateInputValue, this.store.incomingCallType, this.store.incomingConnection, this.store.internalTransferSent, this.store.noteText, this.store.pricingInputValues, this.store.selectedServices, this.store.titleInputValues, this.store.authenticatedUser.in_personal_admin_mode, this.store.scheduledAppointmentDetails, this.store.accountHelpTicketState.accountHelpTicketId);
        (0, utilities_1.assertSucceeded)(sendActionItemResult, utilities_1.handleError);
        await this.handleChatEvents();
        const sendActionItem = sendActionItemResult.value;
        this.store.dispatch(sendActionItem);
        (0, utilities_1.raiseCustomEvent)(this, 'actionitemsent');
        this.closeSubscriptionsIfNecessary();
        this.handleNavigateAwayFromCallScreen();
        this.executeJOHomeSubscriptionsIfEndingCall();
        (0, set_user_back_available_automatically_1.setUserBackAvailableInXMilliseconds)(this.store.authenticatedUser, 5000);
        this.store.loading = false;
    }
    async handleChatEvents() {
        await this.createChatDurationEventIfNecessary();
        await this.closeTwilioConversationIfNecessary();
    }
    async closeTwilioConversationIfNecessary() {
        if (this.store.callScreenMode === 'CHAT' && this.store.chatId !== 'NOT_SET') {
            const twilioConversationSid = await (0, get_twilio_conversation_sid_1.getConversationSidFromChat)(this.store.chatId);
            if (twilioConversationSid) {
                await makeRequestToInteralEndpointToCloseConversation(twilioConversationSid);
            }
        }
    }
    async createChatDurationEventIfNecessary() {
        if (this.store.callScreenMode === 'CHAT' &&
            this.store.chatId !== 'NOT_SET' &&
            this.store.authenticatedUser !== 'NOT_SET') {
            await (0, chat_duration_event_utils_1.createChatDurationEvent)({
                type: 'ACTION_ITEM_SENT',
                userId: this.store.authenticatedUser.id,
                chatId: this.store.chatId,
            });
        }
    }
    async publishContactConnectedToChatIfInChatMode() {
        (0, utilities_1.assertIsSet)(this.store.contact, utilities_1.handleError);
        if (this.store.callScreenMode === 'CHAT' && this.store.chatId !== 'NOT_SET') {
            await (0, mutations_1.publishContactConnectedToChatEvent)(this.store.chatId, this.store.contact.id);
        }
    }
    executeJOHomeSubscriptionsIfEndingCall() {
        if (isCallScreenModeForLiveCall(this.store.callScreenMode)) {
            jo_home_1.JOHomeSubscribable.executeSubscriberCallbacks();
        }
    }
    handleNavigateAwayFromCallScreen() {
        if (this.store.callScreenMode === 'ACTION_ITEM') {
            window.history.back();
            return;
        }
        if (this.store.callScreenMode === 'CHAT') {
            this.closeChatConversation();
            (0, utilities_1.raiseCustomEvent)(this, 'chatConversationClosed', this.store.chatId);
            return;
        }
        // If the user was previously looking at an action item before
        // the call, it would cause state conflicts to return to it.
        // To avoid this for now, simply navigating back to dashboard.
        if (this.store.returnPath.startsWith('/action-item')) {
            (0, utilities_1.navigate)('/');
            return;
        }
        (0, utilities_1.navigate)(this.store.returnPath);
    }
    async holdClicked() {
        (0, utilities_1.assertIsSet)(this.store.authenticatedUser, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.callId, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.direction, utilities_1.handleError);
        this.store.holdButtonEnabled = false;
        const holdClickedResult = await (0, create_hold_clicked_action_1.createHoldClickedAction)({
            authenticatedUser: this.store.authenticatedUser,
            callId: this.store.callId,
            previouslyOnHold: this.store.onHold,
            timestamp: new Date(),
            userCallSid: this.store.userCallSid,
        });
        if (holdClickedResult.succeeded === false) {
            this.store.holdButtonEnabled = true;
            void (0, utilities_1.handleError)(holdClickedResult.developerMessage);
            return;
        }
        const holdClicked = holdClickedResult.value;
        this.store.dispatch(holdClicked);
        this.store.holdButtonEnabled = true;
    }
    async initiateTransfer(e) {
        this.store.dispatch({
            type: 'SHOW_TRANSFER_INITIATED_BOX',
            transferRecipientName: e.detail.transferRecipientName,
            showTransferInitiatedBox: true,
            transferState: 'STARTED',
        });
        (0, utilities_1.raiseCustomEvent)(this, 'caninitiatenewtransferchanged', false);
        (0, utilities_1.assertIsSet)(this.store.authenticatedUser, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.callId, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.companyForTransferInstructions, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.companyId, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.jillCallSid, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.direction, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.userCallSid, utilities_1.handleError);
        this.createUserStatusEventOnCallScreen('CALL_TRANSFER_INITIATED_BY_JILL');
        const transferInitiateActionResult = await (0, create_transfer_initiated_action_1.createTransferInitiateAction)(this.store.authenticatedUser.id, this.store.callId, this.store.companyForTransferInstructions, this.store.companyId, this.store.jillCallSid, this.store.direction, e.detail.transferTo, e.detail.transferRecipientName, this.store.userCallSid);
        if (transferInitiateActionResult.succeeded === false) {
            (0, utilities_1.joAlert)('Error', 'There was an error initiating transfer');
            this.store.dispatch({
                type: 'TRANSFER_INITIATE_FAILED',
            });
            (0, utilities_1.raiseCustomEvent)(this, 'caninitiatenewtransferchanged', true);
            return;
        }
        if (transferInitiateActionResult.value.type ===
            'TRANSFER_INITIATE_CANCEL_JILL_ON_ANOTHER_CALL') {
            this.store.isTransferRecipientJillOnACall = true;
            await (0, utilities_1.wait)(4000);
            this.store.dispatch({
                type: 'TRANSFER_INITIATE_CANCEL_JILL_ON_ANOTHER_CALL',
            });
            (0, utilities_1.raiseCustomEvent)(this, 'caninitiatenewtransferchanged', true);
        }
        if (transferInitiateActionResult.value.type === 'TRANSFER_INITIATE') {
            const transferInitiateAction = transferInitiateActionResult.value;
            this.store.dispatch(transferInitiateAction);
            (0, utilities_1.raiseCustomEvent)(this, 'caninitiatenewtransferchanged', false);
            (0, utilities_1.assertIsSet)(this.store.transferCallSid, utilities_1.handleError);
            await this.subscribeToTransferCallStatus(this.store.transferCallSid);
        }
    }
    async subscribeToTransferCallStatus(transferCallSid) {
        const fetchTransferCallStatusResult = await (0, twilio_1.fetchCallStatus)(transferCallSid);
        (0, utilities_1.assertSucceeded)(fetchTransferCallStatusResult, utilities_1.handleError);
        const transferCallStatus = fetchTransferCallStatusResult.value;
        if ((0, utilities_1.isInternalTransfer)(this.store.transferTo) && transferCallStatus === 'NO_ANSWER') {
            this.store.transferCallStatus = transferCallStatus;
            await (0, utilities_1.wait)(4000);
            this.declineTransfer();
            return;
        }
        const transferCallStatusSubscription = await (0, graphql_1.gqlSubscription)((0, graphql_1.gql) `
                subscription ($transferCallSid: String!) {
                    transferCallStatusCallback(transferCallSid: $transferCallSid)
                }
            `, this.transferCallStatusEventCallback.bind(this), {
            transferCallSid,
        });
        this.store.subscriptions = {
            ...this.store.subscriptions,
            transferCallStatusSubscription: transferCallStatusSubscription ?? 'NOT_SET',
        };
    }
    async transferCallStatusEventCallback(data) {
        (0, utilities_1.assertIsDefined)(data.payload.data.transferCallStatusCallback, 'data.payload.data.transferCallStatusCallback', utilities_1.handleError);
        this.store.transferCallStatus = data.payload.data.transferCallStatusCallback;
        if (this.store.transferState === 'STARTED' &&
            (this.store.transferCallStatus === 'COMPLETED' ||
                this.store.transferCallStatus === 'BUSY' ||
                this.store.transferCallStatus === 'NO_ANSWER')) {
            await (0, utilities_1.wait)(4000);
            this.declineTransfer();
        }
    }
    async declineTransfer() {
        if (this.store.transferState !== 'STARTED') {
            return;
        }
        this.store.dispatch({
            type: 'HIDE_TRANSFER_INITIATED_BOX',
            showTransferInitiatedBox: false,
            transferState: 'NOT_STARTED',
        });
        (0, utilities_1.assertIsSet)(this.store.transferId, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.userCallSid, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.direction, utilities_1.handleError);
        await this.subscribeToJillAndUserReconnectedAfterTransferDecline();
        const transferDeclineActionResult = await (0, create_transfer_decline_action_1.createTransferDeclineAction)(this.store.transferId, this.store.userCallSid);
        (0, utilities_1.assertSucceeded)(transferDeclineActionResult, utilities_1.handleError);
        const transferDeclineAction = transferDeclineActionResult.value;
        this.store.dispatch(transferDeclineAction);
        if (this.store.userCallStatus === 'COMPLETED') {
            this.endCall();
        }
        else {
            (0, utilities_1.raiseCustomEvent)(this, 'caninitiatenewtransferchanged', true);
        }
    }
    async subscribeToJillAndUserReconnectedAfterTransferDecline() {
        const jillAndUserReconnectedAfterTransferDeclineSubscription = await (0, graphql_1.gqlSubscription)((0, graphql_1.gql) `
                    subscription ($jillCallSid: String!, $userCallSid: String!) {
                        jillAndUserReconnectedAfterTransferDecline(
                            jillCallSid: $jillCallSid
                            userCallSid: $userCallSid
                        )
                    }
                `, () => {
            const createJillAndUserReconnectedAfterTransferDeclineActionResult = (0, create_jill_and_user_reconnected_after_transfer_decline_action_1.createJillAndUserReconnectedAfterTransferDeclineAction)(this.store.subscriptions
                .jillAndUserReconnectedAfterTransferDeclineSubscription);
            (0, utilities_1.assertSucceeded)(createJillAndUserReconnectedAfterTransferDeclineActionResult, utilities_1.handleError);
            const jillAndUserReconnectedAfterTransferDeclineAction = createJillAndUserReconnectedAfterTransferDeclineActionResult.value;
            this.store.dispatch(jillAndUserReconnectedAfterTransferDeclineAction);
            (0, utilities_1.raiseCustomEvent)(this, 'caninitiatenewtransferchanged', true);
        }, {
            jillCallSid: this.store.jillCallSid,
            userCallsid: this.store.userCallSid,
        });
        this.store.subscriptions = {
            ...this.store.subscriptions,
            jillAndUserReconnectedAfterTransferDeclineSubscription: jillAndUserReconnectedAfterTransferDeclineSubscription ?? 'NOT_SET',
        };
    }
    async completeTransfer() {
        this.store.dispatch({
            type: 'HIDE_TRANSFER_INITIATED_BOX',
            showTransferInitiatedBox: false,
            transferState: 'COMPLETED',
        });
        (0, utilities_1.assertIsSet)(this.store.transferId, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.userCallSid, utilities_1.handleError);
        (0, utilities_1.assertIsSet)(this.store.transferTo, utilities_1.handleError);
        const transferType = (0, utilities_1.isInternalTransfer)(this.store.transferTo)
            ? 'INTERNAL_TRANSFER'
            : 'EXTERNAL_TRANSFER';
        const transferCompleteActionResult = await (0, create_transfer_complete_action_1.createTransferCompleteAction)(this.store.transferId, this.store.userCallSid, transferType);
        (0, utilities_1.assertSucceeded)(transferCompleteActionResult, utilities_1.handleError);
        const transferCompleteAction = transferCompleteActionResult.value;
        this.store.dispatch(transferCompleteAction);
        this.endCall();
    }
    clearContactButtonEventHandler() {
        this.clearContact();
        this.store.hideSearchContainer = false;
    }
    contactActivityLogSelected(e) {
        this.store.contactForActivityLog = e.detail;
        this.store.showContactActivityLog = true;
    }
    showMergeModal(mergeDetails) {
        this.store.mergeContactDetails = mergeDetails;
    }
    async activityLogActionItemSelected(e) {
        if (this.store.callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
            this.store.callScreenMode === 'OUTGOING_NEW_ACTION_ITEM') {
            const shouldContinue = await (0, utilities_1.joConfirm)('Notice', 'Are you sure you want to use this action item?');
            if (shouldContinue === true) {
                this.store.preserveState = true;
                this.clearContact();
                const newCallScreenModeResult = getNewCallScreenModeForActivityLogSelected(this.store.callScreenMode);
                (0, utilities_1.assertSucceeded)(newCallScreenModeResult, utilities_1.handleError);
                const newCallScreenMode = newCallScreenModeResult.value;
                this.store.showContactActivityLog = false;
                (0, utilities_1.navigate)(`action-item?actionItemId=${e.detail.actionItemId}&callId=${this.store.callId}&companyId=${this.store.companyId}&callScreenMode=${newCallScreenMode}`, true);
            }
        }
        if (this.store.callScreenMode === 'ACTION_ITEM') {
            this.store.showContactActivityLog = false;
            this.store.preserveState = true;
            this.clearContact();
            (0, utilities_1.navigate)(`action-item?actionItemId=${e.detail.actionItemId}&companyId=${this.store.companyId}&callScreenMode=ACTION_ITEM`, true);
        }
    }
    copyActionItemToClipboard() {
        navigator.clipboard.writeText(this.getActionItemResponsesText()).catch(() => {
            (0, utilities_1.joAlert)('Error', 'Failed to copy to clipboard');
        });
    }
    getActionItemResponsesText() {
        if (this.store.pricingInputValues === 'NOT_SET') {
            (0, utilities_1.joAlert)('Error Cannot Copy', 'Must have a service selected to copy');
            return '';
        }
        return (this.store.noteText +
            '\n\n\n' +
            (0, helper_utils_1.createCustomResponsesText)(this.store.selectedServices, this.store.customFieldResponsesInputValues, this.store.pricingInputValues));
    }
    render(state) {
        const serviceAreaDescription = this.store.companyForCallInstructions === 'NOT_SET'
            ? ''
            : this.store.companyForCallInstructions.service_area_description;
        const addressAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_address_appear;
        const addressRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_address_require;
        const checkCounty = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_check_county;
        const checkZipCode = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_check_zip_code;
        const cityAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_city_appear;
        const cityRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_city_require;
        const countyAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_county_appear;
        const countyRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_county_require;
        const emailAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_email_appear;
        const emailRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_email_require;
        const postalCodeAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_postal_code_appear;
        const postalCodeRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_postal_code_require;
        const provinceAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_province_appear;
        const provinceRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_province_require;
        const serviceAreaCounties = state.companyForCollection === 'NOT_SET'
            ? ''
            : state.companyForCollection.service_area_counties;
        const serviceAreaZipCodes = state.companyForCollection === 'NOT_SET'
            ? ''
            : state.companyForCollection.service_area_zip_codes;
        const stateAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_state_appear;
        const stateRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_state_require;
        const whereDidYouHearAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection
                .call_screen_general_information_where_did_you_hear_appear;
        const whereDidYouHearRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection
                .call_screen_general_information_where_did_you_hear_require;
        const zipCodeAppear = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_zip_code_appear;
        const zipCodeRequire = state.companyForCollection === 'NOT_SET'
            ? false
            : state.companyForCollection.call_screen_general_information_zip_code_require;
        return (0, element_vir_1.html) `
            <link rel="stylesheet" href="/styles/jo-styles.css" />
            <link
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
                rel="stylesheet"
            />

            ${styles_1.joCallScreenStyles}

            <jo-loading
                .props=${{
            loading: state.loading,
        }}
            ></jo-loading>

                <div class="jo-call-screen--main-container"> 
                <jo-fade-in-overlay
                    .props=${(0, overlay_modal_1.getPropsForOverlayToDisplayModal)(state)}
                    @contactmerged=${(afterMergeContact) => {
            this.contactSelected(afterMergeContact);
            const currentSearch = this.store.contactInputValuesForSearch;
            this.store.contactInputValuesForSearch = 'NOT_SET';
            requestAnimationFrame(() => {
                this.store.contactInputValuesForSearch = currentSearch;
            });
        }}
                    @closeoverlay=${() => {
            if (!(this.store.showContactActivityLog && this.store.mergeContactDetails)) {
                /**
                 * When both overlays are trying to open, only close the activity log
                 * which is on top. This is really bad but we don't have a scalable
                 * architecture in place for a better solution yet.
                 *
                 * https://jillsoffice.atlassian.net/browse/JWA-1405
                 */
                this.store.mergeContactDetails = undefined;
            }
            this.store.showContactActivityLog = false;
        }}
                    @contactactivitylogselected=${(contactActivityLogSelectedEvent) => {
            this.contactActivityLogSelected(contactActivityLogSelectedEvent);
        }}
                    @activitylogactionitemselected=${async (e) => await this.activityLogActionItemSelected(e)}
                ></jo-fade-in-overlay>                   
                    <div class="flex-row top-row">
                        <div class="f5">
                            <jo-call-screen-company-info
                                    .props=${{
            company: state.companyForCompanyInfo,
            callScreenMode: state.callScreenMode,
            companyId: state.companyId,
        }}
                            ></jo-call-screen-company-info>
                        </div>
                        <div class="f1-5 flex-col" 
                            ?hidden=${shouldHideCallControls(state)}
                        >
                            <div 
                                class="f1 flex-row jo-call-screen--endCallTimer-container">
                                <div class="f1"
                                    ?hidden=${shouldShowCallButtonsContainer(state) === false}
                                >
                                    <jo-button
                                        ?hidden=${shouldShowAnswerButton(state) === false}
                                        .type=${'ACTION_BUTTON_GREEN'}
                                        .inlineStyle=${'font-size: 0.8rem;'} 
                                        .text=${'Answer Call'}                                        
                                        .disabled=${state.answerCallButtonClicked === true}
                                        @joButtonClick=${() => {
            this.store.answerCallButtonClicked = true;
            (0, call_info_for_local_storage_1.setValueOnCallInfoForLocalStorage)('answerCallClicked', true);
            this.answerCall();
        }}
                                    ></jo-button>
                                    
                                    <jo-button
                                        ?hidden=${shouldShowEndCallButton(state) === false}  
                                        .inlineStyle=${'font-size: 0.8rem;'}                               
                                        .type=${'DELETE_BUTTON_1'}
                                        .text=${'End Call'}                                                                               
                                        .disabled=${state.endCallActionHasBeenInitiated === true ||
            (0, utilities_1.shouldDisableCallActionButtonsDuringCall)(state.callScreenMode, state.transferState, state.incomingCallType, state.incomingTransferCompleted)}
                                        @joButtonClick=${() => {
            (0, call_info_for_local_storage_1.setValueOnCallInfoForLocalStorage)('endCallClicked', true);
            this.endCall();
        }}
                                    ></jo-button>    
                                </div>
                                <div 
                                    class="f2"
                                    ?hidden=${shouldHideCallControls(state) || shouldHideCallTime(state)}
                                >
                                    <div 
                                        class="jo-call-screen--timers-container"
                                        ?hidden=${shouldHideCallControls(state) ||
            shouldHideCallTime(state)}
                                    >
                                        <div>Call time: ${state.callDurationMinutes}:${state.callDurationSeconds}</div>
                                        <div>Action item time: ${state.actionItemDurationMinutes}:${state.actionItemDurationSeconds}</div>
                                    </div>

                                    <div ?hidden=${shouldHideCallControls(state) ||
            state.redirectingIncomingCallbackToOutgoing === false}>Redirecting callback...</div>                                     
                                </div>                                        
                            </div>


                            <div class="f1 flex-row"
                                ?hidden=${shouldHideCallControls(state) ||
            shouldShowHoldButtonContainer(state) === false}
                            >
                              

                                <div class="f1"
                                    ?hidden=${shouldHideCallControls(state) ||
            shouldShowEndCallButton(state) === false}
                                >                                        
                                    <jo-button
                                        ?hidden=${shouldHideCallControls(state) ||
            shouldShowEndCallButton(state) === false}
                                        .type=${'SECONDARY_BUTTON_1'}
                                        .inlineStyle=${'font-size: 0.8rem;'} 
                                        .text=${'Dialpad'}
                                        .disabled=${(0, utilities_1.shouldDisableCallActionButtonDialPadDuringCall)(state.callScreenMode, state.transferState, state.incomingCallType, state.incomingTransferCompleted)}
                                        @joButtonClick=${() => (this.store.showDialpad = !this.store.showDialpad)}
                                    ></jo-button>
                                                                        
                                    <div ?hidden=${state.showDialpad === false ||
            shouldShowEndCallButton(state) === false} class="jo-call-screen--dialpad-container">
                                        <jo-call-screen-dialpad @digit=${(e) => this.handleDigitEvent(e)}></jo-call-screen-dialpad>
                                    </div>
                                </div>

                                <div class="f2"
                                    ?hidden=${shouldHideCallControls(state) ||
            shouldShowHoldButton(state) === false}
                                >                                      
                                    <jo-call-screen-hold
                                        .props=${{
            callAnswered: state.callAnswered,
            callScreenMode: state.callScreenMode,
            holdButtonEnabled: state.holdButtonEnabled,
            incomingCallType: state.incomingCallType,
            incomingTransferCompleted: state.incomingTransferCompleted,
            onHold: state.onHold,
            transferState: state.transferState,
        }}
                                        @holdclicked=${() => this.holdClicked()}
                                    ></jo-call-screen-hold>                                        
                                </div>
                            </div>
                        </div>                            
                    </div>                                                            
                    <section class="flex-row jo-global--card jo-call-screen--main-body--container"> 
                        <div class="flex-col">
                                <div id="collapse-icon"
                                    ?hidden=${shouldHideFirstColumn(state) || !shouldHideFlagInfo(state)}
                                    @click=${() => {
            this.handleCollapseArrowIconClickEvent();
        }}                                     
                                    title="Collapse"                                                                            
                                >
                                    <i class="material-icons collapse-icon">
                                        keyboard_arrow_left
                                    </i>
                                </div>     

                                
                                <div                                    
                                    ?hidden=${!shouldHideFirstColumn(state)}
                                    @click=${() => {
            this.handleExpandArrowIconClickEvent();
        }}                                    
                                    title="Expand"                                                                            
                                >
                                    <i class="material-icons expand-icon">
                                        keyboard_arrow_right                                
                                    </i>
                                </div>           
                        </div>                       
                        <div id="column-1"
                            class="flex-col f1"
                            ?hidden=${shouldHideFirstColumn(state)}
                        >                        
                            <div class="jo-call-screen--call-controls-container">                                                          
                                <div 
                                    class="jo-call-screen--contact-search-container"
                                    ?hidden=${shouldHideSearchContainer(state)}
                                >                                    
                                    <jo-call-screen-contact-search
                                        .props=${getPropsForContactSearch(state)}
                                        @contactselected=${(contactSelectedEvent) => this.contactSelected(contactSelectedEvent)}
                                        @contactactivitylogselected=${(contactActivityLogSelectedEvent) => this.contactActivityLogSelected(contactActivityLogSelectedEvent)}                                            
                                        @showmergecontactsmodal=${(contactActivityLogSelectedEvent) => {
            this.showMergeModal({
                contactIds: contactActivityLogSelectedEvent.detail,
            });
        }}
                                    ></jo-call-screen-contact-search>
                                </div>

                                <section class="jo-call-screen--flag-info-container">
                                    
                                    <div 
                                        ?hidden=${shouldHideFlagInfo(state)}
                                        style="margin-bottom:3rem;"
                                    >
                                        ${state.actionItem !== 'NOT_SET'
            ? state.actionItem.action_item_flags.map(flag => (0, element_vir_1.html) `
                                                          <div style="padding-bottom: 0.25rem;">
                                                              <jo-action-item-flag-card
                                                                  .props=${{
                authenticatedUser: state.authenticatedUser,
                actionItemFlag: flag,
            }}
                                                                  @flagAddressed=${() => window.location.reload()}
                                                              ></jo-action-item-flag-card>
                                                          </div>
                                                      `)
            : ''}
                                    </div> 
                                    <div 
                                        ?hidden=${shouldHideFlagInfo(state)}
                                        class="jo-call-screen--flag-button"
                                    >
                                        <jo-button
                                            .type=${'DELETE_BUTTON_1'}
                                            .materialIconName=${'flag'}
                                            @joButtonClick=${() => (this.store.showFlagActionItemForm = true)}
                                        ></jo-button>
                                    </div>   

                                    ${(0, element_vir_1.renderIf)(state.accountHelpTicketState.accountHelpTicketId ===
            undefined, (0, element_vir_1.html) `
                                            <!-- Note: the inline style is required to work for some reason, the class is not working -->
                                            <div
                                                class="jo-call-screen--account-help-button"
                                                style="position: absolute; right: 0.5rem; bottom: 0.5rem;"
                                            >
                                                <jo-button
                                                    .type=${'ACTION_BUTTON_GREEN_2'}
                                                    .materialIconName=${'help'}
                                                    .helpText=${'Submit Help Ticket'}
                                                    .helpTextStyles=${'left: -3rem;'}
                                                    @joButtonClick=${() => {
            this.store.showSubmitHelpTicketForm = true;
        }}
                                                ></jo-button>
                                            </div>
                                        `)}
                                    ${(0, element_vir_1.renderIf)(state.accountHelpTicketState.accountHelpTicketId ===
            undefined, (0, element_vir_1.html) `
                                            <div
                                                class="jo-call-screen--account-help-button"
                                                style="position: absolute; right: 0.5rem; bottom: 0.5rem;"
                                            >
                                                <jo-button
                                                    .type=${'ACTION_BUTTON_GREEN_2'}
                                                    .materialIconName=${'help'}
                                                    .helpText=${'Submit Help Ticket'}
                                                    .helpTextStyles=${'left: -3rem;'}
                                                    @joButtonClick=${() => {
            this.store.showSubmitHelpTicketForm = true;
        }}
                                                ></jo-button>
                                            </div>
                                        `)}
                                </section>
                            </div>                                   

                            <jo-fade-in-overlay
                                .props=${{
            child: (0, element_vir_1.html) `
                                        <div class="jo-global--width-50-vw">
                                            <jo-flag-action-item-form
                                                .props=${{
                actionItem: state.actionItem,
                authenticatedUser: state.authenticatedUser,
            }}
                                            ></jo-flag-action-item-form>
                                        </div>
                                    `,
            showChild: state.showFlagActionItemForm,
        }}
                                @closeoverlay=${() => (this.store.showFlagActionItemForm = false)}
                            ></jo-fade-in-overlay>

                            <jo-fade-in-overlay
                                .props=${{
            child: (0, element_vir_1.html) `
                                        <div class="jo-global--width-50-vw">
                                            <${jo_submit_help_ticket_element_1.JoSubmitHelpTicket}
                                                ${(0, element_vir_1.assign)(jo_submit_help_ticket_element_1.JoSubmitHelpTicket, {
                companyId: (0, replace_not_set_with_undefined_1.replaceNotSetWithUndefined)(state.companyId),
                userId: (0, replace_not_set_with_undefined_1.replaceNotSetWithUndefined)(state.authenticatedUser)?.id,
                quickTitles: state.accountHelpTicketState
                    .quickTitlesForAccountHelpTicket,
            })}
                                                ${(0, element_vir_1.listen)(jo_submit_help_ticket_element_1.JoSubmitHelpTicket.events.submitted, event => {
                this.store.accountHelpTicketState = {
                    ...this.store.accountHelpTicketState,
                    accountHelpTicketId: event.detail,
                };
                this.store.showSubmitHelpTicketForm = false;
            })}
                                                ${(0, element_vir_1.listen)(jo_submit_help_ticket_element_1.JoSubmitHelpTicket.events.cancel, () => {
                this.store.showSubmitHelpTicketForm = false;
            })}
                                            ></${jo_submit_help_ticket_element_1.JoSubmitHelpTicket}>
                                        </div>
                                    `,
            showChild: state.showSubmitHelpTicketForm,
        }}
                                @closeoverlay=${() => (this.store.showSubmitHelpTicketForm = false)}
                            ></jo-fade-in-overlay>
                        </div>

                        <div class="f8 flex-row ">
                        
                            <div id="column-2" class="flex-col split${this.store.hideSearchContainer ? 'left-space' : ''}">                                                                                                                                                       
                                                        
                                <div id="contact-split-container" class="jo-call-screen--contact-container">  
                                    <jo-contact
                                        .props=${{
            actionItemId: state.actionItemId,
            authenticatedUser: state.authenticatedUser,
            contact: state.contact,
            contactInputValues: state.contactInputValues,
            requiredIconType: 'EXPLICIT',
            addressAppear,
            addressRequire,
            checkCounty,
            checkZipCode,
            cityAppear,
            cityRequire,
            countyAppear,
            countyRequire,
            emailAppear,
            emailRequire,
            hideClearContactButton: (0, utilities_1.shouldShowContactSearchFunctionality)(state.callScreenMode, state.actionItemId) === false,
            mode: state.callScreenMode === 'ACTION_ITEM'
                ? 'ACTION_ITEM'
                : 'ACTIVE_CALL_SCREEN',
            postalCodeAppear,
            postalCodeRequire,
            provinceAppear,
            provinceRequire,
            serviceAreaCounties,
            serviceAreaDescriptionAppear: serviceAreaDescription.length === 0
                ? false
                : true,
            serviceAreaDescription,
            serviceAreaZipCodes,
            stateAppear,
            stateRequire,
            whereDidYouHearAppear,
            whereDidYouHearRequire,
            zipCodeAppear,
            zipCodeRequire,
        }}
                                        @inputvalueschanged=${(e) => {
            e.stopPropagation();
            this.store.contactInputValues = e.detail;
        }}
                                        @joContactInputBlur=${(e) => {
            this.store.contactInputValuesForSearch = e.detail;
        }}
                                        @clearcontact=${() => {
            this.clearContactButtonEventHandler();
        }}
                                        @contactchanged=${(e) => {
            this.store.contact = e.detail;
        }} 
                                        @joContactDialPhoneNumberClicked=${async (e) => await (0, twilio_1.handleDialPhoneNumberClickedOnJOContact)(e, this, this.saveContact.bind(this))}
                                        @contactactivitylogselected=${(e) => this.contactActivityLogSelected(e)}                                                                                                                                                           
                                    ></jo-contact>
                                </div>
                                                                                    
                                <div id="instructions-split-container" class="jo-call-screen--instructions-container">
                                    <jo-call-screen-call-instructions
                                        .props=${{
            company: state.companyForCallInstructions,
        }}
                                    ></jo-call-screen-call-instructions>
                                </div>  
                                
                                    
                            </div>

                            <div id="column-3" class="flex-col ">
                                <div class="jo-call-screen--collection-container">
                                    <jo-call-screen-collection
                                        .props=${{
            actionItem: state.actionItem,
            actionItemId: state.actionItemId,
            settingUpInitialCallScreenInfoHasInitiated: state.settingUpInitialCallScreenInfoHasInitiated,
            actionItemTitles: state.actionItemTitles,
            actionItemQuickNotes: state.actionItemQuickNotes,
            authenticatedUser: state.authenticatedUser,
            calculatedPrice: state.calculatedPrice,
            callAnswered: state.callAnswered,
            callEnded: state.callEnded,
            callId: state.callId,
            callScreenMode: state.callScreenMode,
            canInitiateNewTransfer: state.canInitiateNewTransfer,
            chatId: state.chatId,
            chatMessengerInput: state.chatMessengerInput,
            chatMessengerQuickNotes: state.chatMessengerQuickNotes,
            companyForCollection: state.companyForCollection,
            companyForTransferInstructions: state.companyForTransferInstructions,
            companyId: state.companyId,
            contact: state.contact,
            customFieldResponsesInputValues: state.customFieldResponsesInputValues,
            contactInputValues: this.store.contactInputValues,
            direction: state.direction,
            externalTransferPhoneNumberInputValue: state.externalTransferPhoneNumberInputValue,
            followupRequestDateInputValue: state.followupRequestDateInputValue,
            incomingCallType: state.incomingCallType,
            incomingTransferCompleted: state.incomingTransferCompleted,
            isTransferRecipientJillOnACall: state.isTransferRecipientJillOnACall,
            jillCallSid: state.jillCallSid,
            jillInteractionMode: this.store.jillInteractionMode,
            jillsToTransferTo: state.jillsToTransferTo,
            minimumPriceApplied: state.minimumPriceApplied,
            noteText: state.noteText,
            outboundAttemptId: state.outboundAttemptId,
            previousCustomFieldResponses: state.previousCustomFieldResponses,
            previousLineItemResponses: state.previousLineItemResponses,
            previousServiceResponses: state.previousServiceResponses,
            priceQuote: state.priceQuote,
            pricingInputValues: state.pricingInputValues,
            quickTitlesForActionItem: state.quickTitlesForActionItem,
            redirectingIncomingCallbackToOutgoing: state.redirectingIncomingCallbackToOutgoing,
            saveActionItemInitiated: state.saveActionItemInitiated,
            serviceAreaDescription,
            selectedJillForTransfer: state.selectedJillForTransfer,
            selectedServices: state.selectedServices,
            selectedServicesWithCalculatedPrice: state.selectedServicesWithCalculatedPrice,
            showTransferInitiatedBox: state.showTransferInitiatedBox,
            transferCallSid: state.transferCallSid,
            transferCallStatus: state.transferCallStatus,
            transferId: state.transferId,
            transferRecipientName: state.transferRecipientName,
            transferState: state.transferState,
            transferTo: state.transferTo,
            userCallSid: state.userCallSid,
            userCallStatus: state.userCallStatus,
        }}
                                        @actionItemTitleChanged=${(e) => this.handleActionItemTitleChangedEvent(e)}
                                        @actionItemSubTitleChanged=${(e) => this.handleActionItemSubTitleChangedEvent(e)}
                                        @appointmentScheduled=${(e) => {
            this.store.scheduledAppointmentDetails = e.detail;
        }}
                                        @copyActionItemToClipboard=${() => {
            this.copyActionItemToClipboard();
        }}
                                        @chatMessengerInputChanged=${(e) => {
            this.store.chatMessengerInput = e.detail;
        }}
                                        @notetextchanged=${(e) => (this.store.noteText = e.detail)}
                                        @serviceselected=${(e) => this.handleServiceSelected(e.detail.checked, e.detail.service)}
                                        @endcall=${() => this.endCall()}                                                                               
                                        @transferstatechanged=${(e) => (this.store.transferState = e.detail)}
                                        @internalTransferSent=${() => (this.store.internalTransferSent = true)}
                                        @externalTransferSent=${() => (this.store.externalTransferSent = true)}
                                        @followuprequestdateinputvaluechanged=${(e) => (this.store.followupRequestDateInputValue = e.detail)}
                                        @actionitemsendtocompany=${(e) => this.sendActionItem(e)}
                                        @actionitemsendtocallbacks=${(e) => this.sendActionItem(e)}
                                        @actionitemsave=${(e) => this.sendActionItem(e)}
                                        @customfieldresponsesinputvalueschanged=${(e) => {
            this.store.customFieldResponsesInputValues = e.detail;
        }}
                                        @pricinginputvalueschanged=${(e) => {
            this.store.dispatch({
                type: 'UPDATE_PRICING',
                pricingInputValues: e.detail,
            });
        }}
                                        @titleinputvalueschanged=${(e) => (this.store.titleInputValues = e.detail)}
                                        @transferinitiated=${(e) => this.initiateTransfer(e)}
                                        @declinetransferclicked=${() => this.declineTransfer()}
                                        @completetransferclicked=${() => this.completeTransfer()} 
                                        @jillInteractionModeChanged=${(e) => {
            this.store.jillInteractionMode = e.detail;
        }}
                                        @jillselectedfortransfer=${(e) => (this.store.selectedJillForTransfer = e.detail)}
                                        @externaltransferphonenumberinputvalue=${(e) => (this.store.externalTransferPhoneNumberInputValue =
            e.detail)}
                                        @saveActionItemButtonClicked=${() => (0, call_info_for_local_storage_1.setValueOnCallInfoForLocalStorage)('saveActionItemClicked', true)}                                    
                                    ></jo-call-screen-collection>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>                               
            </div>                      
        `;
    }
    updateContactInCallScreenState(callScreenState, contactInputValues) {
        const updatedContact = getUpdatedContact(contactInputValues);
        return {
            ...callScreenState,
            contact: updatedContact,
        };
    }
    handleActionItemTitleChangedEvent(e) {
        this.store.actionItemTitles = {
            ...this.store.actionItemTitles,
            title: e.detail,
        };
    }
    handleActionItemSubTitleChangedEvent(e) {
        this.store.actionItemTitles = {
            ...this.store.actionItemTitles,
            subtitle: e.detail,
        };
    }
    handleExpandArrowIconClickEvent() {
        const column1 = this.querySelector('#column-1');
        const icon = this.querySelector('#collapse-icon');
        this.store.hideSearchContainer = false;
        column1?.classList.add('slide-in-animation');
        column1?.addEventListener('animationend', () => {
            this.slideInAnimationEndEventListener(column1, icon);
            this.store.hideSearchContainer = false;
        }, { once: true });
    }
    handleCollapseArrowIconClickEvent() {
        const column1 = this.querySelector('#column-1');
        const icon = this.querySelector('#collapse-icon');
        icon?.classList.add('hide');
        column1?.classList.add('slide-out-animation');
        column1?.addEventListener('animationend', () => {
            this.slideOutAnimationEndEventListener(column1, icon);
        }, { once: true });
    }
    slideInAnimationEndEventListener(column1, icon) {
        column1.classList.remove('slide-in-animation');
        icon?.classList.remove('hide');
    }
    slideOutAnimationEndEventListener(column1, icon) {
        this.store.hideSearchContainer = true;
        column1.classList.remove('slide-out-animation');
    }
}
exports.JOCallScreen = JOCallScreen;
(0, define_custom_element_1.defineCustomElement)(exports.joCallScreenTagName, JOCallScreen);
async function makeRequestToInteralEndpointToCloseConversation(twilioConversationSid) {
    const formData = new FormData();
    formData.append('conversationSid', twilioConversationSid);
    await (0, utilities_1.sendRouterRequest)('/conversation/endConversation', formData);
}
function getUpdatedContact(contactInputValues) {
    return {
        id: contactInputValues.contactId,
        addresses: getAddresses(contactInputValues),
        company_name: contactInputValues.businessNameInputValue,
        email: contactInputValues.emailInputValue,
        first_name: contactInputValues.firstNameInputValue,
        last_name: contactInputValues.lastNameInputValue,
        phone_numbers: getPhoneNumbers(contactInputValues),
        sales: contactInputValues.sales,
        status: getContactStatus(contactInputValues),
        where_did_you_hear_about_us: contactInputValues.whereDidYouHearAboutUsInputValue,
    };
}
function getContactStatus(contactInputValues) {
    return contactInputValues.status === 'BLOCKED' ? 3 : 0;
}
function getPhoneNumbers(contactInputValues) {
    return contactInputValues.phoneNumbersInputValues.map(input => {
        return {
            id: input.phoneNumberId,
            number: input.phoneNumber,
        };
    });
}
function getAddresses(contactInputValues) {
    return contactInputValues.addressesInputValues.map(input => {
        return {
            city: input.cityInputValue,
            county: input.countyInputValue,
            id: input.addressId,
            line_1: input.line1InputValue,
            line_2: input.line2InputValue,
            postal_code: input.postalCodeInputValue,
            province: input.provinceInputValue,
            state: input.stateInputValue,
            zip_code: input.zipCodeInputValue,
        };
    });
}
function isCallScreenModeForLiveCall(callScreenMode) {
    return (callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
        callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM' ||
        callScreenMode === 'OUTGOING_EXISTING_ACTION_ITEM' ||
        callScreenMode === 'OUTGOING_NEW_ACTION_ITEM');
}
function shouldHideFirstColumn(state) {
    if (state.callScreenMode === 'ACTION_ITEM' && state.actionItemId !== 'NOT_SET') {
        return false;
    }
    return state.hideSearchContainer;
}
function shouldHideSearchContainer(state) {
    if (state.callScreenMode === 'ACTION_ITEM' && state.actionItemId !== 'NOT_SET') {
        return true;
    }
    return state.hideSearchContainer;
}
function shouldHideFlagInfo(state) {
    return (state.callScreenMode !== 'ACTION_ITEM' ||
        !(0, auth_rules_1.isJillAtOrAboveAuthRole)(state.authenticatedUser, 'JILL_OUTBOUND') ||
        state.actionItemId === 'NOT_SET');
}
function getPropsForContactSearch(state) {
    const contactId = getContactIdToPassIntoContactSearch(state);
    const email = state.contactInputValuesForSearch === 'NOT_SET'
        ? 'NOT_SET'
        : state.contactInputValuesForSearch.emailInputValue;
    const firstName = state.contactInputValuesForSearch === 'NOT_SET'
        ? 'NOT_SET'
        : state.contactInputValuesForSearch.firstNameInputValue;
    const lastName = state.contactInputValuesForSearch === 'NOT_SET'
        ? 'NOT_SET'
        : state.contactInputValuesForSearch.lastNameInputValue;
    const phoneNumbers = state.contactInputValuesForSearch === 'NOT_SET'
        ? []
        : state.contactInputValuesForSearch.phoneNumbersInputValues.map((phoneNumberInputValues) => phoneNumberInputValues.phoneNumber);
    return {
        addressCities: getAddressValuesForSearch('cityInputValue', state.contactInputValuesForSearch),
        addressLines1: getAddressValuesForSearch('line1InputValue', state.contactInputValuesForSearch),
        addressLines2: getAddressValuesForSearch('line2InputValue', state.contactInputValuesForSearch),
        addressStates: getAddressValuesForSearch('stateInputValue', state.contactInputValuesForSearch),
        addressZipCodes: getAddressValuesForSearch('zipCodeInputValue', state.contactInputValuesForSearch),
        companyId: state.companyId,
        contactId: typeof contactId === 'number' ? contactId : -1,
        email,
        firstName,
        lastName,
        phoneNumbers,
        canAssignNewContactToActionItem: (0, jo_call_screen_utils_1.getCanAssignNewContactToActionItem)(state),
        callScreenMode: state.callScreenMode,
        authenticatedUser: state.authenticatedUser,
    };
}
function getContactIdToPassIntoContactSearch(state) {
    if (state.callScreenMode === 'ACTION_ITEM' &&
        state.actionItem !== 'NOT_SET' &&
        typeof state.contact !== 'symbol') {
        return state.contact.id;
    }
    if (state.contactInputValuesForSearch === 'NOT_SET')
        return 'NOT_SET';
    return typeof state.contact === 'symbol' ? -1 : state.contact.id;
}
function getAddressValuesForSearch(key, contactInputValuesForSearch) {
    if (contactInputValuesForSearch === 'NOT_SET')
        return [];
    return contactInputValuesForSearch.addressesInputValues.map(addressInputValues => addressInputValues[key]);
}
function shouldShowHoldButton(state) {
    if (state.redirectingIncomingCallbackToOutgoing === true) {
        return false;
    }
    if ((state.callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM') &&
        state.callAnswered === true &&
        state.callEnded === false &&
        state.incomingConnection !== 'NOT_SET') {
        return true;
    }
    // TODO really we should wait until we have definitely connected with the user on an outgoing call
    if ((state.callScreenMode === 'OUTGOING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'OUTGOING_EXISTING_ACTION_ITEM') &&
        state.callEnded === false &&
        state.incomingConnection !== 'NOT_SET') {
        return true;
    }
    return false;
}
function shouldShowHoldButtonContainer(state) {
    if (shouldShowHoldButton(state) === true || shouldShowEndCallButton(state) === true) {
        return true;
    }
    return false;
}
function shouldShowCallButtonsContainer(state) {
    if (shouldShowAnswerButton(state) === true || shouldShowEndCallButton(state) === true) {
        return true;
    }
    return false;
}
function shouldShowAnswerButton(state) {
    if ((state.callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM') &&
        state.callAnswered === false &&
        state.incomingConnection !== 'NOT_SET' &&
        state.callId !== 'NOT_SET') {
        return true;
    }
    return false;
}
function shouldShowEndCallButton(state) {
    if (state.redirectingIncomingCallbackToOutgoing === true) {
        return false;
    }
    if ((state.callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM') &&
        state.callAnswered === true &&
        state.callEnded === false &&
        state.incomingConnection !== 'NOT_SET') {
        return true;
    }
    // TODO really we should wait until we have definitely connected with the user on an outgoing call
    if ((state.callScreenMode === 'OUTGOING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'OUTGOING_EXISTING_ACTION_ITEM') &&
        state.callEnded === false &&
        state.incomingConnection !== 'NOT_SET') {
        return true;
    }
    return false;
}
function shouldSubscribeToUserCallStatus(state) {
    if ((state.callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM') &&
        state.incomingCallType !== 'NOT_SET' &&
        state.jillCallSid !== 'NOT_SET' &&
        state.userCallSid !== 'NOT_SET' &&
        state.subscriptions.userCallStatusSubscription === 'NOT_SET') {
        return true;
    }
    if ((state.callScreenMode === 'OUTGOING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'OUTGOING_EXISTING_ACTION_ITEM') &&
        state.jillCallSid !== 'NOT_SET' &&
        state.userCallSid !== 'NOT_SET' &&
        state.subscriptions.userCallStatusSubscription === 'NOT_SET') {
        return true;
    }
    return false;
}
function shouldSubscribeToIncomingTransferResolved(state) {
    if ((state.callScreenMode === 'INCOMING_NEW_ACTION_ITEM' ||
        state.callScreenMode === 'INCOMING_EXISTING_ACTION_ITEM') &&
        state.incomingCallType === 'TRANSFER' &&
        state.jillCallSid !== 'NOT_SET' &&
        state.userCallSid !== 'NOT_SET' &&
        state.subscriptions.incomingTransferResolvedSubscription === 'NOT_SET') {
        return true;
    }
    return false;
}
function shouldHideCallControls(state) {
    if (state.callScreenMode === 'ACTION_ITEM' || state.callScreenMode === 'CHAT') {
        return true;
    }
    return false;
}
function getNewCallScreenModeForActivityLogSelected(callScreenMode) {
    if (callScreenMode === 'INCOMING_NEW_ACTION_ITEM') {
        return {
            succeeded: true,
            value: 'INCOMING_EXISTING_ACTION_ITEM',
        };
    }
    if (callScreenMode === 'OUTGOING_NEW_ACTION_ITEM') {
        return {
            succeeded: true,
            value: 'OUTGOING_EXISTING_ACTION_ITEM',
        };
    }
    return {
        succeeded: false,
        userMessage: 'There was an error',
        developerMessage: `getNewCallScreenModeForActivityLogSelected error: callScreenMode ${callScreenMode} is not supported`,
    };
}
function wasScreenRefreshedDuringCall(state) {
    // This scenario means the jill has probably refreshed her screen during an incoming call
    if (state.callScreenMode.startsWith('INCOMING') &&
        state.collectingDuration === false &&
        state.incomingCallType === 'NOT_SET' &&
        state.callAnswered === false &&
        state.incomingConnection === 'NOT_SET') {
        return true;
    }
    // This scenario means the jill has probably refreshed her screen during an outgoing call
    if (state.callScreenMode.startsWith('OUTGOING') &&
        state.collectingDuration === false &&
        state.incomingCallType === 'NOT_SET' &&
        state.callAnswered === false &&
        state.incomingConnection === 'NOT_SET') {
        return true;
    }
    return false;
}
exports.wasScreenRefreshedDuringCall = wasScreenRefreshedDuringCall;
function shouldHideCallTime(state) {
    if (state.callScreenMode.startsWith('INCOMING') && state.callAnswered === false) {
        return true;
    }
    if (state.incomingCallType === 'CALLBACK') {
        return true;
    }
    return false;
}
function isInActiveCallMode(callScreenMode) {
    if (callScreenMode.startsWith('INCOMING') || callScreenMode.startsWith('OUTGOING')) {
        return true;
    }
    return false;
}
